import React from 'react';
import css from './ShowFilters.module.css';

import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle, faTimes } from '@fortawesome/free-solid-svg-icons';

import { createResourceLocatorString } from '../../../util/routes';
import routeConfiguration from '../../../routeConfiguration';

const LABEL_MAP = {
  price: 'Price',
  address: 'Location',
  page: 'Page No',
  pub_category: 'Categories',
  pub_language: 'Languages',
  'pub_meeting-type': 'Meeting types',
  pub_per: 'Unit type',
  'pub_type-of-service': 'Type of service',
  keywords: 'Keyword',
  bounds: null,
};

function ShowFilters(props) {
  const { searchParams, history } = props;
  const entries = Object.entries(searchParams);

  const activeEntries = entries.filter(([key]) => LABEL_MAP[key] != null);

  const onRemove = key => {
    const next = { ...searchParams, [key]: undefined };
    if (key === 'address') next.bounds = undefined;
    history.push(createResourceLocatorString('SearchPage', routeConfiguration(), {}, next));
  };

  if (activeEntries.length === 0) return null;

  return (
    <div className={css.base}>
      <div className={css.chips}>
        {activeEntries.map(([key, value]) => {
          const label = LABEL_MAP[key];
          const parts = String(value).split(',');
          const count = parts.length;

          return (
            <div key={key} className={css.chip}>
              {/* × remove badge */}
              <button
                type="button"
                className={css.removeBadge}
                onClick={() => onRemove(key)}
                aria-label={`Remove ${label} filter`}
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>

              {/* label + count */}
              <p className={css.chipLabel}>
                {label} <span className={css.chipCount}>({count})</span>
              </p>

              {/* value */}
              <p className={css.chipValue}>
                {parts.join(', ')}
              </p>
            </div>
          );
        })}
      </div>

      <button
        type="button"
        className={css.clearBtn}
        onClick={() => history.push('/s')}
      >
        Clear filters <FontAwesomeIcon icon={faTimesCircle} />
      </button>
    </div>
  );
}

export default withRouter(ShowFilters);
